import getCdiData from './getCdiData'
import getVinculos from './getVinculos'
import getMatches from './getMatches';

export const getCdiDataPromise = getCdiData;
export const getVinculosPromise = getVinculos;
export const getMatchesPromise = getMatches;